import { ButtonComponent } from '../../../components/UI/ButtonComponent/ButtonComponent';
import './BrandsAndBuyers.scss';
import { useWindowSize } from '../../../hooks/useWindowSize';
import { Buyers, Brands, verifiedLabel } from './model';

export default function BrandsAndBuyers() {
	const windowsSize = useWindowSize().width;
	const SMALL_MOBILE = 600;
	const navigateDiscoverProds = () => {
		window.location.href = `${window.location.origin}/products`;
	};
	const navigateWhatsNew = () => {
		window.location.href = `${window.location.origin}/products?whats_new=new&new_to_beacon=true`;
	};
	const navigateGetOnBeacon = () => {
		window.location.href = `${window.location.origin}/getonbeacon`;
	};
	return (
		<main className='brands-and-buyers'>
			<div className='row-brands-buyers '>
				<section className='buyers'>
					<div className=' verified-label'>
						<span>
							{' '}
							<i className='ri-checkbox-circle-line icon'></i> {verifiedLabel}
						</span>
					</div>
					<h3 className='section-title'>{Buyers.heading}</h3>
					<p className='section-text'>{Buyers.description}</p>
					<div className='attributes'>
						<span className='text'>
							{' '}
							<i className='ri-award-line icon'></i>
							{Buyers.brandMetricsValue}
						</span>{' '}
						<span className='text'>
							<i className='ri-arrow-right-up-line icon'></i>
							{Buyers.productMetricsValue}
						</span>
					</div>
					<div className='attributes-description buyers'>
						<span>{Buyers.brandMetricsText}</span>
						<span>{Buyers.productMetricsText}</span>
					</div>

					<div className='button-container-buyers'>
						<ButtonComponent
							text={Buyers.productsButton}
							onClick={navigateDiscoverProds}
							style='rounded-button primary'
							icon={<i className='ri-arrow-right-s-line line-icon'></i>}
						/>
						<ButtonComponent
							text={Buyers.whatsNew}
							onClick={() => {
								navigateWhatsNew();
							}}
							style='rounded-button secondary'
						/>
					</div>
				</section>

				<section className='brands'>
					<div className='verified-label'>
						<span>
							{' '}
							<i className='ri-checkbox-circle-line icon'></i> {verifiedLabel}
						</span>
					</div>
					<h3 className='section-title'>{Brands.heading}</h3>
					<p className='section-text'>{Brands.description}</p>
					{windowsSize > SMALL_MOBILE && (
						<div className='attributes brands'>
							<span className='text net-sales'>
								{' '}
								<i className='ri-money-dollar-circle-line icon'></i>
								{Brands.netSalesValue}
							</span>{' '}
							<span className='arrow-text avg-velocity'>
								<i className='ri-arrow-right-up-line icon'></i>
								{Brands.avgVelocityValue}
							</span>
							<span className='text acv-increase'>
								<i className='ri-add-fill icon'></i>
								{Brands.acvValue}
							</span>
						</div>
					)}
					{windowsSize > SMALL_MOBILE && (
						<div className='attributes-description brands'>
							<span className='text net-sales'>{Brands.netSalesText}</span>
							<span className='velocity-text '>{Brands.avgVelocityText}</span>
							<span className='text acv-increase'>{Brands.acvText}</span>
						</div>
					)}
					{windowsSize <= SMALL_MOBILE && (
						<div className='attributes-mobile'>
							<span className='stat net-sales'>
								{' '}
								<i className='ri-money-dollar-circle-line icon'></i>
								{Brands.netSalesValue}
							</span>
							<span className='text net-sales'>{Brands.netSalesText}</span>
							<span className='stat avg-velocity'>
								{' '}
								<i className='ri-arrow-right-up-line icon'></i>
								{Brands.avgVelocityValue}
							</span>
							<span className='text avg-velocity'>{Brands.avgVelocityText}</span>
							<span className='stat acv-increase'>
								{' '}
								<i className='ri-add-fill icon'></i>
								{Brands.acvValue}
							</span>
							<span className='text acv-increase'>{Brands.acvText}</span>
						</div>
					)}
					<div className='button-container-brands'>
						<ButtonComponent
							text={Brands.getOnBeaconButton}
							onClick={navigateGetOnBeacon}
							style='rounded-button primary'
							icon={<i className='ri-arrow-right-s-line line-icon'></i>}
						/>
						<ButtonComponent
							text={Brands.productsButton}
							onClick={navigateDiscoverProds}
							style='rounded-button secondary'
						/>
					</div>
				</section>
			</div>
		</main>
	);
}
